<template>
  <div class="textblock">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-2 is-size-3-mobile">{{ headline }}</h1>
        </div>
      </div>
    </div>
    <div class="section is-medium">
      <div class="container">
        <div class="columns">
          <div class="column is-size-6 is-size-7-mobile">{{ column1 }}</div>
          <div class="column is-size-6 is-size-7-mobile">{{ column2 }}</div>
        </div>
        <presslogo />
      </div>
    </div>
  </div>
</template>

<script>
import Presslogo from "@/components/Presslogo.vue";
export default {
  name: "Textblock",
  components: {
    Presslogo
  },
  props: {
    headline: String,
    column1: String,
    column2: String
  }
};
</script>

<style lang="scss"></style>
